import { useState, useContext } from "react";
import { ToastContext } from "../../../hooks/context";
import { useEditCreditLimitMutation } from "../../../hooks/api/mutations/useInventory";
import { useQueryClient } from "react-query";
import { useGetCustomerDetails } from "../../../hooks/api/queries";

const useUpdateCreditLogLogic = ({
  closeModal = () => {},
  onSuccess = () => {},
  customer,
}) => {
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const customerId = customer?.id || customer?.customer_id;
  const { data: customerDetails, isLoading: isLoadingCustomerDetails } =
    useGetCustomerDetails(customerId);
  const [creditLimit, setCreditLimit] = useState(
    customerDetails?.credit_limit || customer?.credit_limit || "",
  );

  const editCreditLimitMutation = useEditCreditLimitMutation();
  const updateCreditLimitById = () => {
    editCreditLimitMutation.mutate(
      { id: customerId, credit_limit: Number(creditLimit) },
      {
        onSuccess: () => {
          onSuccess(Number(creditLimit));
          queryClient.invalidateQueries([
            "getCustomerDetails",
            `${customerId}`,
          ]);
          queryClient.invalidateQueries(["getCustomers"]);
          triggerToast("Credit Limit Updated Successfully", "success");
          closeModal();
        },
      },
    );
  };

  return {
    creditLimit,
    isUpdating: editCreditLimitMutation.isLoading,
    customerDetails,
    isLoadingCustomerDetails,
    updateCreditLimitById,
    setCreditLimit,
  };
};
export default useUpdateCreditLogLogic;
